import { PotentialGain, type RevenueOpportunity } from '../entities/site-list';

export const dummySiteRevenueOpportunity: RevenueOpportunity[] = [
  {
    fullFrontendId: 'Country_Corner',
    revenueOpportunity: 17200,
    potentialGain: PotentialGain.Low,
  },
  {
    fullFrontendId: 'Smart_Hill',
    revenueOpportunity: 34600,
    potentialGain: PotentialGain.Medium,
  },
  {
    fullFrontendId: 'Sunset_Plaza',
    revenueOpportunity: 58900,
    potentialGain: PotentialGain.High,
  },
];
